import { PointEntity } from '@src/features/order/entities';

export function buildGoHereErrorPath(
  origin: google.maps.LatLngLiteral | null,
  goHerePoints: PointEntity[],
): google.maps.LatLngLiteral[] {
  if (!origin) return [];
  const targets = goHerePoints
    .map((p) => p.position)
    .filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  if (targets.length === 0) return [];
  return [origin, ...targets];
}
